<template>
  <m-tab step="demo">
    <div class="m-tab-top-box" v-if="!isBusiness">Use the tabs below to define your target audience using demographic or interest and purchasing attributes</div>
    <div class="m-tab-top-box" v-if="isBusiness">Use the tabs below to define your target audience using business types and demographic options</div>
    <div class="m-tabs" v-if="tabs.length !== 1">
      <!-- <b-link v-for = "item in tabs"
              v-show="item.demoType !== 'quickPicks' || (item.demoType === 'quickPicks' && exitQuickPick)"
              :key="item.demoType"
              v-if="item.access"
              class="m-tab"
              :class = "{'m-tab-active': demoOption === item.demoType}"
              @click = "getRoute(item)"
              :data-test="`demo-box-tab-${item.demoType}`"
              >{{item.title}}</b-link> -->
              
        <div v-for = "item in tabs"
             v-show="item.demoType !== 'quickPicks' || (item.demoType === 'quickPicks' && exitQuickPick)"
             :key="item.demoType"
             class="m-tab"
             :class = "{'m-tab-active': demoOption === item.demoType}"
             >
             <b-link
              v-if="item.access"
              @click = "getRoute(item)"
              :data-test="`demo-box-tab-${item.demoType}`"
              :style = "{'margin-right': (item.video !== '' ? '2%' : '0' )}"
             >{{item.title}}</b-link>
             
            <a data-fancybox :href = "item.video" style="display: flex;" v-if = "item.video !== ''" >
              <img src="../../assets/images/video-play-16.png" alt="Video" />
            </a>
        </div>
    </div>
    <b-container fluid>
      <div class="top-btn-box">
        <div  class="bootom-btn">
          <b-btn @click="goBack">Back</b-btn>
          <div class="next-box">
            <b-btn variant="primary"
                      @click="next"
                      :disabled ="nextDisabled">Next</b-btn>
            <!--<p class="next-desc">{{nextDesc}}</p>-->
          </div>
        </div>
        <slot name="top" >
        </slot>
      </div>

      <slot></slot>
      <b-row style="margin-top:7px;">
        <b-col md="5" offset-md="7">
          <span v-if = "hasSaveQuickPick && exitQuickPick"
                class="m-link-go"
                @click = "saveQuickPick">Save As a QuickPick </span>
        </b-col>
      </b-row>
      <b-row v-show="!isHidePhoneOption" class="phone-row">
        <b-col>
          <h4>Phone Option</h4>
        </b-col>
      </b-row>
      <b-row v-show="alertDesc!==''" style="margin-top: 16px;margin-bottom: -16px;margin-left: 8px">
        <b-col>
          <b-alert  variant="warning" v-html="alertDesc" show></b-alert>
        </b-col>
      </b-row>
      <b-row >
        <b-col class="box">
          <m-phone-option />
          <!-- <span v-if = "hasSaveQuickPick && exitQuickPick"
                class="m-link-go"
                @click = "saveQuickPick">Save As a QuickPick </span> -->
        </b-col>
      </b-row>     
      <b-row v-show="showEmailOption" class="phone-row">
        <b-col>
          <h4>Email Option</h4>
        </b-col>
      </b-row>
      <b-row v-show="showEmailOption" >
        <b-col class="box">
          <m-email-option />
        </b-col>
      </b-row> 

      <b-row class="m-box-bottom" style="margin-top: -8px">

        <div class="bootom-btn">
          <b-btn @click="goBack">Back</b-btn>
          <div class="next-box">
            <b-btn variant="primary"
                   @click="next"
                   data-test="demo-next"
                   :disabled ="nextDisabled">Next</b-btn>
            <!--<p class="next-desc">{{nextDesc}}</p>-->
          </div>
        </div>
        <span>

        </span>
        <span class="m-link-go" v-if = "hasTotalRecords && datasource.hasRecordsWithPhone">
          <span @click = "showTotalRecords" v-b-popover.hover="'See a total number of records with and without phone numbers.'">View breakdown of records with and without phone numbers</span>
          <!--<span style="margin-left: 50px;"-->
            <!--v-b-popover.hover="'See a total number of records with and without phone numbers.'"-->
            <!--title="">Explain these options </span>-->
        </span>
      </b-row>
    </b-container>
  </m-tab>
</template>

<script>
  import MTab from '@/components/elements/MTab'
  import MPhoneOption from '@/components/demo/MPhoneOption'
  import MEmailOption from '@/components/demo/MEmailOption'

  export default {
    components: {
      MPhoneOption,
      MTab,
      MEmailOption
    },
    props: {
      demoOption: {
        type: String,
        default: 'demo'  // 'normal', 'quickPick', 'suppression', 'search', 'demo', 'interests', 'audience'
      },
      hasSaveQuickPick: {
        type: Boolean,
        default: true
      },
      hasTotalRecords: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        alertDesc: ''
      }
    },
    created () {
    },
    computed: {
      isBusiness () {
        let type = this.$store.state.order.ListType
        return [20, 90, 120, 160, 170, 180, 210, 260].indexOf(type) > -1
      },
      showEmailOption () {
        // return this.$store.state.order.ListType === 260
        return false
      },
      datasource () {
        return this.$store.getters['config/datasource']
      },
      listType () {
        return this.$store.state.order.ListType
      },
      hasPhoneOption () {
        return this.$store.getters['order/hasPhoneOption']
      },
      hasEmailOption () {
        return this.$store.getters['order/hasEmailOption']
      },
      hasDemo () {
        return this.$store.getters['order/hasDemo']
      },
      tabs () {
        return this.$store.getters['config/datasource'].demoTabs
      },
      hasGeo () {
        return this.$store.getters['order/hasGeo']
      },
      geoItems () {
        return this.$store.getters['order/geoItems']
      },
      currentGeoType () {
        return this.$store.getters['config/currentGeoType']
      },
      nextDesc () {
        if (this.hasGeo) {
          return 'Poll Count'
        } else {
          return 'Select Area'
        }
      },
      isTargetoption () {
        return this.$store.getters['demo/isTargetoption']
      },
      isRouteoption () {
        return this.$store.getters['demo/isRouteoption']
      },
      exitQuickPick () {
        let demoTabs = this.$store.getters['config/datasource'].demoTabs
        let tabHasQuickPick = false
        for (let demo of demoTabs) {
          if (demo.demoType === 'quickPicks') {
            tabHasQuickPick = true
          }
        }
        return this.$store.state.demo.hasQuickPicks || tabHasQuickPick
      },
      isHidePhoneOption () {
        return this.$store.getters['demo/isHidePhoneOption']
      },
      nextDisabled () {
        if (this.$store.state.order.CurrentStep === 'count') {
          return true
        }
        if (!this.hasDemo) {
          return true
        }
        // if (!this.hasPhoneOption) {
        //   return true
        // }
        if (this.listType === 50 && !this.isTargetoption) {
          return true
        }
        if (this.listType === 50 && !this.isRouteoption) {
          return true
        }
      },
      noPhoneOption () {
        return this.$store.getters['demo/noPhoneOption']
      }
    },
    methods: {
      getRoute (item) {
        this.$router.push({name: 'demo-' + item.demoType})
      },
      saveQuickPick () {
        this.$root.$emit('bv::show::modal', 'saveQuickPick')
      },
      next () {
        this.alertDesc = ''
        // check have phoneOption
        if (!this.hasDemo) {
          this.alertDesc += 'Please Defined Target Audience<br>'
        }
        if (!this.hasPhoneOption && !this.noPhoneOption && this.isHidePhoneOption) {
          this.alertDesc += 'Please select a Phone Option<br>'
        }
        if (this.listType === 50 && !this.isTargetoption) {
          this.alertDesc += 'Please select at least one targeting option<br>'
        }
        if (this.listType === 50 && !this.isRouteoption) {
          this.alertDesc += 'Please select at least one route option<br>'
        }
        if (this.alertDesc === '') {
          if (this.hasGeo || this.$store.state.order.GeoType === 20 || this.$store.state.order.GeoType === 23) {
            this.$store.dispatch('order/submitOrder')
          } else {
            this.$router.push({name: 'geo'})
          }
        }
      },
      goBack () {
        this.$router.push({name: 'geo'})
      },
      showTotalRecords () {
        this.$root.$emit('bv::show::modal', 'totalRecords')
      }
    },
    watch: {
      '$route.name' () {
        if (this.listType === 50 && this.$route.name === 'demo-demoDemographics') {
          this.$router.push('/order/50/demo/residentOccupantList')
        }
      }
    }
  }
</script>

<style scoped lang="scss">



  .box {
    padding: 16px 32px;
    justify-content: space-between;
  }
  .phone-option-item {
    display: inline-block;
  }
  .iclude-dnc-list{
    display: block;
    margin-left: 16px;
  }
  .next-desc {
    color: $color-border;
    font-size: 13px;
    margin-bottom: 0;
  }
  .next-box {
    flex-direction: column;
    display: flex;
    justify-content:center;
    align-items: center;
    margin-left: 16px;
  }
  .bootom-btn {
    display: flex;
    align-items: flex-start;
  }
  .top-btn-box {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    margin-top: 16px;
    padding: 0 16px;
  }
  .phone-row {
    margin-top: 16px;
    margin-bottom: -8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/demo/M1DemoBox.vue